<script lang="ts" setup>
import { useRoute } from "#app"; // Properties

// Properties
const props = defineProps({
  tabs: {
    type: Object as PropType<{ key: string; label: string }[]>,
    default: null,
  },
  initialActiveTab: {
    type: String,
    default: null,
  },
});

// Data
const activeTab = ref();
const route = useRoute();
const router = useRouter();

// Functions
function clickTab(val: string) {
  activeTab.value = val;
  router.replace({
    path: route.path,
    query: {
      tab: val,
    },
  });
}

if (props.tabs?.length > 0) {
  activeTab.value = props.tabs[0].key;
}

const queryTab = route.query.tab;
if (queryTab) {
  activeTab.value = queryTab;
} else if (props.initialActiveTab) {
  activeTab.value = props.initialActiveTab;
}
</script>

<template>
  <div>
    <!-- Tab view -->
    <div class="tab-content">
      <ul class="flex list-none gap-x-1 overflow-auto lg:gap-x-2">
        <NuxtLink
          v-for="obj in tabs"
          :key="obj.key"
          @click.prevent="clickTab(obj.key)"
          :href="
            router.resolve({
              path: route.path,
              query: {
                tab: obj.key,
              },
            })
          "
        >
          <li
            class="border border-b-0 px-2 py-1 hover:border-b-0 hover:bg-gray-100 lg:px-4"
            :class="activeTab === obj.key ? 'border-b-0 bg-gray-100' : 'border-gray-200 bg-white'"
          >
            {{ obj.label }}
          </li>
        </NuxtLink>
      </ul>

      <div class="bg-grc-gray px-2 py-2 lg:px-8 lg:py-8">
        <div v-for="obj in tabs" v-show="activeTab === obj.key" :key="`tab-body-${obj.key}`">
          <slot :name="obj.key" :click-tab="clickTab"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
